<template>
   <div class="m-5">
        <hamburger :path="$route.path" />
        <div class="bg-secondary p-3 mb-5 rounded-lg flex justify-between items-center">
            <h1 class="text-lg font-semibold uppercase">Edit New Theme</h1>
        </div>

        <div class="w-full md:w-3/5">
            <form-theme-create :id="$route.params.id"/>
        </div>
    </div>
</template>


<script>
import hamburger from '~/components/common/hamburger.vue'
import formThemeCreate from '~/components/common/form/theme.vue'

export default {
  name: 'CreateThemePage',
  components: {
    formThemeCreate,
    hamburger
  },
  layout: 'UserNavigation',
    transition: "slide-bottom",
}
</script>